const Historia = () => {

return (

<div>

<h1>Historia</h1>

</div>

)

}

export default Historia
